// extracted by mini-css-extract-plugin
export var statItem = "_m4-1";
export var statsRow = "_m4-0";